// Guest-mode wrappers — mirrors Diver's Horizon's needsSignIn / guest-preview-wrap pattern: real content
// blurred behind a contextual sign-in CTA (GuestPreview), or a hard lock with no data at all for
// endpoints that are actually auth-gated on the backend (GuestLocked, e.g. Carpool).

export function GuestPreview({ message, onSignIn, children }) {
  return (
    <div className="guest-preview-wrap">
      <div className="guest-preview-blur">{children}</div>
      <div className="guest-preview-cta">
        <p>{message}</p>
        <button className="btn-accent" onClick={onSignIn}>
          Sign in / sign up
        </button>
      </div>
    </div>
  );
}

export function GuestLocked({ message, onSignIn }) {
  return (
    <div className="glass guest-locked">
      <p className="sec-dek">{message}</p>
      <button className="btn-accent" onClick={onSignIn}>
        Sign in / sign up
      </button>
    </div>
  );
}
